import { PERFORMANCE_LEVEL_LABELS, PERFORMANCE_LEVEL_CONFIGS } from 'constants/performanceLevel.constant';
import { SCORE_SCALE_CONSTANT } from 'reports/had/constants/had.constant';
var SEPARATE_CHAR = '%';
export var mergeAndSumByCourseId = function (courseList) {
    return courseList.reduce(function (merged, course) {
        var existingCourse = merged.find(function (item) { return item.courseId === course.courseId; });
        if (existingCourse) {
            existingCourse.assignmentAverageScore += course.assignmentAverageScore;
            existingCourse.assignmentBelowClassAverage += course.assignmentBelowClassAverage;
            existingCourse.assignmentsNotStarted += course.assignmentsNotStarted;
            existingCourse.assignmentsInProgress += course.assignmentsInProgress;
            existingCourse.assignmentsCompleted += course.assignmentsCompleted;
            existingCourse.assignmentsPassedDue += course.assignmentsPassedDue;
        }
        else {
            merged.push(course);
        }
        return merged;
    }, []);
};
export var getMixedIdByStudentExam = function (_a) {
    var examDate = _a.examDate, examId = _a.examId, cohortId = _a.cohortId, cohortMeanHesiScore = _a.cohortMeanHesiScore;
    return [examId, examDate, cohortId, cohortMeanHesiScore].join(SEPARATE_CHAR);
};
export var getExamDataByMixedId = function (id) {
    var _a = (id || '').split(SEPARATE_CHAR), examId = _a[0], examDate = _a[1], cohortId = _a[2], cohortMeanHesiScore = _a[3];
    return { examId: Number(examId), examDate: examDate, cohortId: Number(cohortId), cohortMeanHesiScore: Number(cohortMeanHesiScore) };
};
export var getReportCardsData = function (_a) {
    var activeCWCourses = _a.activeCWCourses, activeSHCourses = _a.activeSHCourses, handleCWCardClick = _a.handleCWCardClick, handleSHCardClick = _a.handleSHCardClick, cwPillTittle = _a.cwPillTittle, shPillTittle = _a.shPillTittle, _b = _a.isSherpathDisabled, isSherpathDisabled = _b === void 0 ? false : _b, _c = _a.isShadowHealthDisabled, isShadowHealthDisabled = _c === void 0 ? false : _c;
    return [
        {
            id: 'build-knowledge-cw',
            footerLinkTitle: "Review My Active Sherpath Courses",
            onFooterLinkClick: handleCWCardClick,
            pillIconName: 'neuroimagery',
            pillTittle: cwPillTittle,
            mainTitle: "".concat(activeCWCourses, " courses"),
            captionText: 'Active Sherpath Courses',
            isDisabled: isSherpathDisabled
        },
        {
            id: 'apply-clinical-judgement-sh',
            footerLinkTitle: "Review My Active Shadow Health Courses",
            onFooterLinkClick: handleSHCardClick,
            pillIconName: 'stethoscope',
            pillTittle: shPillTittle,
            mainTitle: "".concat(activeSHCourses, " courses"),
            captionText: 'Active Shadow Health Courses',
            isDisabled: isShadowHealthDisabled
        }
    ];
};
export var buildPerformanceLevelColumnChartDataCohort = function (cohorts) {
    var _a;
    if (cohorts === void 0) { cohorts = []; }
    var performanceLevelCount = (_a = {},
        _a[PERFORMANCE_LEVEL_LABELS.atRisk] = 0,
        _a[PERFORMANCE_LEVEL_LABELS.belowAcceptable] = 0,
        _a[PERFORMANCE_LEVEL_LABELS.acceptable] = 0,
        _a[PERFORMANCE_LEVEL_LABELS.recommended] = 0,
        _a);
    cohorts.forEach(function (_a) {
        var likelyHESIExitScore = _a.likelyHESIExitScore, meanHesiExitScore = _a.meanHesiExitScore;
        if (likelyHESIExitScore) {
            return;
        }
        if (meanHesiExitScore < SCORE_SCALE_CONSTANT.MAX_AT_RISK) {
            performanceLevelCount[PERFORMANCE_LEVEL_LABELS.atRisk] += 1;
        }
        else if (SCORE_SCALE_CONSTANT.MAX_AT_RISK <= meanHesiExitScore && meanHesiExitScore < SCORE_SCALE_CONSTANT.MAX_BELOW_ACCEPTABLE) {
            performanceLevelCount[PERFORMANCE_LEVEL_LABELS.belowAcceptable] += 1;
        }
        else if (SCORE_SCALE_CONSTANT.MAX_BELOW_ACCEPTABLE <= meanHesiExitScore && meanHesiExitScore < SCORE_SCALE_CONSTANT.MAX_ACCEPTABLE) {
            performanceLevelCount[PERFORMANCE_LEVEL_LABELS.acceptable] += 1;
        }
        else if (SCORE_SCALE_CONSTANT.MAX_ACCEPTABLE <= meanHesiExitScore) {
            performanceLevelCount[PERFORMANCE_LEVEL_LABELS.recommended] += 1;
        }
    });
    var rangeLevelBarChartData = Object.values(PERFORMANCE_LEVEL_CONFIGS).map(function (_a) {
        var label = _a.label, range = _a.range, fillColorClassName = _a.fillColorClassName, stripeStrokeColorClassName = _a.stripeStrokeColorClassName;
        var value = performanceLevelCount[label];
        return {
            name: range,
            subLabel: label,
            value: value,
            fillColorClassName: fillColorClassName,
            stripeStrokeColorClassName: stripeStrokeColorClassName
        };
    });
    var rangeLevelBarChartConfig = {
        barSize: 65,
        xAxisKey: 'name',
        yAxisKey: 'value',
        isStripeColorUsed: false,
        margin: { top: 30, right: 0, bottom: 0, left: 0 }
    };
    return {
        data: rangeLevelBarChartData,
        config: rangeLevelBarChartConfig
    };
};
